import styles from "../../styles/Components/alert-system/AlertStrategy.module.css";
import useFetchAlertStrategies from "../../hooks/api/alert-system/useFetchAlertStrategies";
import useServiceStatus from "../../hooks/useServiceStatus";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import CreateNewStrategyBox from "./alert-strategy/CreateNewStrategyBox";
import StrategyItem from "./alert-strategy/StrategyItem";
import { FaBell } from "react-icons/fa";
import ServiceActivationModal from "../../shared/service-activation/ServiceActivationModal";
import { useState } from "react";

function AlertStrategy() {
  const {
    alertSystem: { alertStrategiesStatus, allStrategies },
  } = useSelector((state) => state);

  const [showServiceActivation, setShowServiceActivation] = useState(false);

  const { isActive: isAlertSystemActive } = useServiceStatus("alert");

  const isLoading = alertStrategiesStatus === "loading";

  useFetchAlertStrategies();

  return (
    <div className={styles.container}>
      {!isAlertSystemActive && (
        <div className={styles.inactiveServiceBox}>
          <div className={styles.title}>
            <div className={styles.iconWrapper}>
              <FaBell className={styles.bellIcon} />
            </div>
            <h3>Unlock Custom Strategy Alerts</h3>
          </div>
          <p>
            {" "}
            Activate the Alert System to start receiving smart, personalized
            signals based on your strategies.
          </p>
          <span
            className={styles.activateButton}
            onClick={() => setShowServiceActivation(true)}
          >
            Activate Now
          </span>

          {showServiceActivation && (
            <ServiceActivationModal
              show={showServiceActivation}
              setShow={setShowServiceActivation}
              service="alert"
            />
          )}
        </div>
      )}
      {isAlertSystemActive && (
        <div className={styles.strategyList}>
          {isLoading &&
            Array.from({ length: 3 }).map((_, i) => (
              <Skeleton.Node key={i} active />
            ))}

          {!isLoading &&
            allStrategies?.map((strategy) => (
              <StrategyItem key={strategy.createdDate} data={strategy} />
            ))}

          {!isLoading && <CreateNewStrategyBox />}
        </div>
      )}
    </div>
  );
}

export default AlertStrategy;
